export const COMPANY = {
  name: "AD Brikman",
  fullName: "AD Brikman Usługi Brukarskie",
  phone: "535 616 324",
  phoneRaw: "+48535616324",
  email: "adbrikman@gmail.com",
  street: "ul. Wiosenna 7",
  postal: "21-010 Łęczna",
  region: "woj. lubelskie",
  site: "https://adbrikman.pl",
  googleProfile: "https://share.google/GWZuCe3N2gjHa30Jv",
  whatsapp: "https://wa.me/48535616324?text=Dzie%C5%84%20dobry%2C%20pisz%C4%99%20w%20sprawie%20wyceny%20prac%20brukarskich.",
};

export const CITIES = [
  "Łęczna", "Lublin", "Świdnik", "Łuszczów", "Cyców", "Podzamcze",
  "Turka", "Turowola", "Trębaczów", "Milejów", "Kalinówka", "Marysin",
  "Stasin", "Zemborzyce", "Wesołówka", "Jakubowice",
];

export const SERVICES = [
  {
    id: "kostka-brukowa",
    title: "Kostka brukowa",
    short: "Podjazdy, parkingi, place manewrowe",
    desc: "Układamy kostkę brukową w różnych formatach i kolorach — na solidnej podbudowie, z zachowaniem spadków i odwodnienia. Nawierzchnie odporne na obciążenia i mróz, zadbana fuga i równe linie.",
    photo: "/photos/photo-01.jpg",
  },
  {
    id: "plyty-tarasowe",
    title: "Płyty tarasowe i ceramiczne",
    short: "Tarasy, wykroty, strefy wypoczynku",
    desc: "Montaż trwałych i eleganckich płyt tarasowych oraz ceramicznych. Odporność na mróz, łatwe utrzymanie czystości i nowoczesny wygląd dopasowany do bryły domu.",
    photo: "/photos/photo-16.jpg",
  },
  {
    id: "plyty-chodnikowe",
    title: "Płyty chodnikowe",
    short: "Chodniki, ścieżki, ciągi piesze",
    desc: "Chodniki i ścieżki ogrodowe z płyt chodnikowych — funkcjonalne ciągi komunikacyjne wokół domu i w przestrzeniach wspólnych.",
    photo: "/photos/photo-09.jpg",
  },
  {
    id: "palisady-obrzeza",
    title: "Palisady i obrzeża",
    short: "Krawędzie, wzmocnienia, formy terenu",
    desc: "Palisady, obrzeża trawnikowe i krawężniki: wyznaczają krawędzie, wzmacniają nawierzchnie i porządkują przestrzeń ogrodu.",
    photo: "/photos/photo-12.jpg",
  },
  {
    id: "opaski",
    title: "Opaski wokół domu",
    short: "Opaski, podmurówki, dojścia",
    desc: "Opaski wokół budynku chronią fundament i nadają posesji dopracowany, kompletny wygląd. Idealnie skorelowane z podjazdem i tarasem.",
    photo: "/photos/photo-05.jpg",
  },
  {
    id: "garaze-altany",
    title: "Nawierzchnie pod garaże i altany",
    short: "Stabilne podłoże pod zabudowania",
    desc: "Wykonujemy nawierzchnie pod garaże, altany i inne zabudowania gospodarcze — wyrównane, zagęszczone i odporne na osiadanie.",
    photo: "/photos/photo-19.jpg",
  },
  {
    id: "brukarstwo-artystyczne",
    title: "Brukarstwo artystyczne",
    short: "Nietypowe wzory, mozaiki, koła",
    desc: "Nasza specjalność: dekoracyjne układy, koła, mozaiki i nietypowe kompozycje z kostki. Nawierzchnia jako ozdoba posesji, nie tylko podłoże.",
    photo: "/photos/photo-22.jpg",
  },
  {
    id: "dla-firm",
    title: "Usługi dla firm i administratorów",
    short: "Parkingi, drogi wewnętrzne, place",
    desc: "Prace brukarskie na rzecz firm i administratorów nieruchomości: parkingi, drogi wewnętrzne, place i ciągi komunikacyjne. Terminowo i zgodnie z umową.",
    photo: "/photos/photo-08.jpg",
  },
  {
    id: "projekt-materialy",
    title: "Projekt i dobór materiałów",
    short: "Doradzamy, modyfikujemy, pomagamy kupić",
    desc: "Pomagamy w wyborze i modyfikacji projektu, doradzamy w doborze kostki i płyt oraz pomagamy w zakupie materiałów u sprawdzonych producentów. Prace wykonujemy od A do Z lub w zakresie preferowanym przez klienta.",
    photo: "/photos/photo-14.jpg",
  },
];

export const PHOTO_GALLERY = Array.from({ length: 23 }, (_, i) => ({
  src: `/photos/photo-${String(i + 1).padStart(2, "0")}.jpg`,
  category: ["podjazdy", "tarasy", "opaski", "chodniki"][i % 4],
}));

export const GALLERY_CATEGORIES = [
  { id: "all", label: "Wszystkie" },
  { id: "podjazdy", label: "Podjazdy i place" },
  { id: "tarasy", label: "Tarasy" },
  { id: "opaski", label: "Opaski i obrzeża" },
  { id: "chodniki", label: "Chodniki i ścieżki" },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Wizja lokalna", desc: "Oglądamy teren, mierzymy spadki, sprawdzamy grunt i doradzamy najlepsze rozwiązanie." },
  { n: "02", title: "Projekt i dobór materiałów", desc: "Pomagamy w wyborze i modyfikacji projektu, dobieramy kostkę oraz pomagamy w zakupie materiałów." },
  { n: "03", title: "Niwelacja i podbudowa", desc: "Korekta terenu, formowanie spadków i warstwowa podbudowa odpowiednia dla nawierzchni." },
  { n: "04", title: "Układanie", desc: "Precyzyjne układanie kostki i płyt — równe linie, kontrola poziomicą i niwelatorem." },
  { n: "05", title: "Fugowanie i odbiór", desc: "Zasypywanie fug, zagęszczanie, sprzątanie terenu i wspólny odbiór prac." },
];

export const STATIC_PAGES = [
  { path: "/", label: "Strona główna" },
  { path: "/uslugi", label: "Usługi" },
  { path: "/realizacje", label: "Realizacje" },
  { path: "/o-nas", label: "O nas" },
  { path: "/blog", label: "Blog" },
  { path: "/kontakt", label: "Kontakt" },
];
